import regeneratorRuntime from "regenerator-runtime";

require('./../../css/chriscorchado.css')
require('./../../css/pages/company.css')
require('./../../css/header/navigation.css')
require('./../../css/header/pagination.css')
require('./../../css/header/search.css')

require('../../js/search.js')
require('../../js/utilities.js')
require('../../js/data.js')
require('../../js/chriscorchado.js')
